import * as RTK from '@reduxjs/toolkit';
import { Fixtuur } from '@fixtuur/backpack';
import * as immer from 'immer';

export interface State {
    currentRoom: Fixtuur.Room.Room;
}

export const initialState: State = {
    // default room size
    currentRoom: Fixtuur.Room.createRectangleMeters({ height: 2.4, width: 1.5, depth: 1.5 }),
};

export const slice = RTK.createSlice({
    name: 'room',
    initialState,
    reducers: {
        setRoom(
            state,
            action: RTK.PayloadAction<{ height: number; width: number; depth: number }>,
        ) {
            const room = immer.castImmutable(state.currentRoom) as Fixtuur.Room.Room;

            state.currentRoom = Fixtuur.Room.updateRectangle(
                Fixtuur.Measurement.createMeters(action.payload.width),
                Fixtuur.Measurement.createMeters(action.payload.depth),
            )(room);
        },
        setSelectedFurniture(state, action: RTK.PayloadAction<string>) {
            const room = immer.castImmutable(state.currentRoom) as Fixtuur.Room.Room;
            state.currentRoom = Fixtuur.Room.updateSelectedFurniture(action.payload)(room);
        },
        addFurniture(state, action: RTK.PayloadAction<Fixtuur.Furniture.Furniture>) {
            const room = immer.castImmutable(state.currentRoom) as Fixtuur.Room.Room;
            state.currentRoom = Fixtuur.Room.addFurniture(action.payload)(room);
        },
        removeSelectedFurniture(state, action: RTK.PayloadAction<string>) {
            const room = immer.castImmutable(state.currentRoom) as Fixtuur.Room.Room;
            state.currentRoom = Fixtuur.Room.removeSelectedFurniture(action.payload)(room);
        },
        rotateSelectedFurniture(state, action: RTK.PayloadAction<[string, number]>) {
            const room = immer.castImmutable(state.currentRoom) as Fixtuur.Room.Room;
            state.currentRoom = Fixtuur.Room.rotateSelectedFurniture(...action.payload)(room);
        },
    },
});

export const {
    setRoom,
    setSelectedFurniture,
    addFurniture,
    removeSelectedFurniture,
    rotateSelectedFurniture,
} = slice.actions;

export const reducer = slice.reducer;
